import { useQueryClient } from "@tanstack/react-query";
import { Session, STORAGEKEY } from "@/lib/curio";
import { LoginCredentials } from "@/types/auth";
import { useConnectQuery } from "./useConnectQuery";
import { useLoginMutation } from "./useLoginMutation";

export const useAuthQuery = () => {
  const queryClient = useQueryClient();
  const connectQuery = useConnectQuery();
  const loginMutation = useLoginMutation();
  const hasToken = !!sessionStorage.getItem(STORAGEKEY);

  const isLoading = hasToken ? connectQuery.isLoading || loginMutation.isPending : false;
  const sessionData = loginMutation.data ?? connectQuery.data;
  const isAuth = !!sessionData && sessionData instanceof Session;
  const session = sessionData instanceof Session ? sessionData : undefined;

  const login = (credentials: LoginCredentials) => {
    return loginMutation.mutateAsync(credentials);
  };

  const logout = () => {
    loginMutation.reset();
    sessionStorage.clear();
    localStorage.clear();
    queryClient.clear();
  };

  return {
    session,
    isLoading,
    isAuth,
    login,
    logout,
    isConnecting: connectQuery.isLoading,
    isLoggingIn: loginMutation.isPending,
    connectError: connectQuery.error,
    loginError: loginMutation.error
  };
};
